
class Invite {
    [x: string]: any;
 	 static $inject = ['Users','Toast','$location','ModalService', 'AmplitudeService'];
    constructor(Users, Toast, $location, ModalService, AmplitudeService) {
        this.Users = Users;
        this.toast = Toast;
        this.$location = $location;
        this.ModalService = ModalService;
        this.amplitude = AmplitudeService;
        this.editMode = false;
    }

    invite() {
        this.Users.inviteAgain({}, {invitation: {roleId: this.user.roleId, email: this.user.username}}, () => {
            this.amplitude.logEvent('Panel:Users:Invite: Re-send invitation');
            this.toast.success('USERS.INVITATION_SENT');
        });
    }

    cancelInvitation() {
        let message = {
            title: "CANCEL_INVITATION_TITLE",
            body: "CANCEL_INVITATION_CONTENT"
        };
        this.ModalService.showModalConfirm(message).then(() => this.cancelInvitationRequest());
    }

    cancelInvitationRequest() {
        this.Users.cancelInvitation({email: this.user.username}, {}, () => {
          this.amplitude.logEvent('Panel:Users:Invite: Invitation cancelled');
            this.toast.success('USERS.CANCEL_INVITATION');
            this.$location.url('/users/all');
        })
    }

    onUpdateMsisdns(msisdns) {
      this.msisdns = msisdns;
    }

    changeEditMode(){
      this.editMode = !this.editMode;
    }

    savePhoneNumbers() {
     this.Users.editPending({invitationId: this.user.id}, {id: this.user.id, msisdns: this.msisdns}, () => {
        this.amplitude.logEvent('Panel:Users:Invite: Invitation phone numbers changed');
        this.toast.success('USERS.EDIT_PHONE_NUMBERS_SUCCESS');
        this.user.msisdns = this.msisdns;
        this.changeEditMode();
      });
    }

}

export default {
    controller: Invite,
    template : require('./users.invite.exist.html'),
    bindings: {user: '<'}
};
